import { Camera } from 'lucide-react';
import { Box, Flex, Text, chakra } from '@chakra-ui/react';
import type { SettingsFormReturn } from '../useSettingsForm';

export function ProfileCard({ form }: { form: SettingsFormReturn }) {
  const { profileImage, profileImagePreview, firstName, lastName, name, userRole, isVolunteer, profileImageInputRef, handleProfileImageChange } = form;
  return (
    <Flex
      bg="white"
      borderRadius="2xl"
      p="6"
      boxShadow="0 8px 24px rgba(0,0,0,0.12)"
      flexDir="column"
      align="center"
      textAlign="center"
      h={{ lg: 'full' }}
      justify={{ lg: 'center' }}
      w={{ lg: 'full' }}
    >
      <Box position="relative" mb="4">
        <chakra.img
          src={profileImagePreview || profileImage || '/blank-profile.png'}
          alt="Profile"
          w="32"
          h="32"
          borderRadius="full"
          objectFit="cover"
          border="4px solid"
          borderColor="volyx.borderLight"
          onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
            (e.target as HTMLImageElement).src = '/blank-profile.png';
          }}
        />
        <chakra.button
          position="absolute"
          bottom="0"
          right="0"
          w="11"
          h="11"
          bg="volyx.action"
          color="white"
          borderRadius="full"
          display="flex"
          alignItems="center"
          justifyContent="center"
          border="4px solid"
          borderColor="white"
          cursor="pointer"
          transition="transform 0.2s"
          _hover={{ transform: 'scale(1.05)' }}
          onClick={() => profileImageInputRef.current?.click()}
        >
          <Camera size={22} />
        </chakra.button>
        <input
          ref={profileImageInputRef}
          id="profile-image-input"
          name="profile-image"
          type="file"
          accept="image/*"
          style={{ display: 'none' }}
          onChange={handleProfileImageChange}
        />
      </Box>
      <Text as="h2" fontSize="xl" fontWeight="semibold" color="volyx.primary" mb="1">
        {isVolunteer ? `${firstName} ${lastName}` : name}
      </Text>
      <Text fontSize="md" color="volyx.textSecondary">
        {isVolunteer ? (userRole === 'ayan' ? 'Ayan' : 'Volunteer') : 'Organization'}
      </Text>
    </Flex>
  );
}
